module.exports = __webpack_public_path__ + "img/yt-hero1-3-desktop-eng.5a8b314a.png";